import {
    PRICE_POLICIES_SAVE_ROLES_BONIFICATIONS_BEGIN,
    PRICE_POLICIES_SAVE_ROLES_BONIFICATIONS_SUCCESS,
    PRICE_POLICIES_SAVE_ROLES_BONIFICATIONS_FAILURE
} from '../constants'

export function reducer(state, action) {
    switch (action.type) {
        case PRICE_POLICIES_SAVE_ROLES_BONIFICATIONS_BEGIN:
            return {
                ...state,
                roleBonificationError: false,
                roleBonificationPending: true
            }
        case PRICE_POLICIES_SAVE_ROLES_BONIFICATIONS_SUCCESS:
            return {
                ...state,
                roleBonificationSuccess: action.data.roleBonificationSuccess, 
                roleBonificationError: false,
                roleBonificationPending: false
            }
        case PRICE_POLICIES_SAVE_ROLES_BONIFICATIONS_FAILURE:
            return {
                ...state,
                roleBonificationError: action.data.roleBonificationError,
                roleBonificationPending: false
            }
        default:
            return state
    }
}
